import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
class ResumeComponent extends React.Component{
    

    render(){
        return(
<>

<section  id="resume"  className="resume">
                <div className="section-inner start-page-full-width">
                <div className="start-page-full-width">
                        <h2 className="section-title">Resume</h2>
                                                <h5 className="text-right">12 Years of Experience</h5>
<div className="row">
    <div className="col-xs-12 col-sm-8 col-md-8 col-lg-7 pull-left">

    <div className="edu">
    <h3>Professional Experiences:</h3>

    
    
    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">Jun 2012 Continue</h5>
				<span className="item-company">Fareportal India Pvt. Ltd.</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">Sr. Web Designer/ Frontend Developer</h4>
				<p><b>Role and Responsibilities:</b> I am working on flight pages of cheapoair.com, and onetravel.com and developing new promotional pages for booking enhancement. using new technology like bootstrap, and react js, javascript, calling deals in xslt and rest API using javascript and Ajax and  Developing Responsive News Letter which is compatible with all email clients.</p>
			</div>
	</div>

    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">Jun 2009 to Jun 2012</h5>
				<span className="item-company">The Energy and Resources Institute</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">Web Designer</h4>
				<p><b>Role and Responsibilities:</b> Desgining Home Page, using tool Photoshop, and developing it, whith html CSS and jquery.</p>
			</div>
	</div>


    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">Jan 2007 to May 2009 </h5>
				<span className="item-company">Candid Software Pvt. Ltd.</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">Web Designer</h4>
				<p><b>Role and Responsibilities:</b> Desgining Pages, using tool Photoshop, and developing it in html/CSS.</p>
			</div>
		</div>

    </div>

        
    <div className="edu">
    <h3>Educational Qualification:</h3>

    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">2017</h5>
				<span className="item-company">SMU</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">MBA IT</h4>
				<p><b>Details:</b> I have done MBA from SMU, Class attended on Weakend</p>
			</div>
	</div>
    
    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">2013</h5>
				<span className="item-company">MDU</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">MSc Computer Science</h4>
				<p><b>Details:</b> I have done MSc from Maharshi Dayanand University, Weakend Classes</p>
			</div>
	</div>

    


    <div className="edu-item">
			<div className="left-panel col-4">
				<h5 className="item-period">2006</h5>
				<span className="item-company">Arena Multimedia</span>
			</div>
			<div className="devider"></div>
			<div className="right-panel col-7">
				<h4 className="item-title">PIM (Proffesional in Multimedia)</h4>
				<p><b>Covered Tools:</b> Illustrator, Photoshop, Flash,In Design, Premier, After Efect, 3D Max</p>
			</div>
		</div>

    </div>


</div>
<div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 pull-right">
<div className="keyskill">
<h3>Coding Skills</h3>
<div className="skills">
<h4>React<span>55%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" style={{width: '55%'}}></div></div>
</div>
 <h4>JavaScript<span>75%</span></h4>
    <div className="skill-border">
    <div className="progress">
        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width: '75%'}}></div>
    </div>
</div>
<h4>HTML/CSS<span>100%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style={{width: '100%'}}></div></div>
</div>
<h4>News Letter<span>100%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{width: '100%'}}></div></div>
</div>
<h4>Jquery<span>85%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width: '85%'}}></div></div>
</div>
<h4>xslt/XML<span>75%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style={{width: '75%'}}></div></div>
</div>
<h4>ES6<span>55%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" style={{width: '55%'}}></div></div>
</div>


<h4>Angular<span>30%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{width: '30%'}}></div></div>
</div>
<br />

<h3>CMS / Frameworks</h3>
<h4>BootStrap<span>95%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style={{width: '95%'}}></div></div>
</div>

<h4>Wordpress  <span>50%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{width: '50%'}}></div></div>
</div>
<h4>Opencart<span>60%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: '60%'}}></div></div>
</div>
<br/>
<h3>Design Skills</h3>
<h4>Webdesign<span>100%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style={{width: '100%'}}></div></div>
</div>
<h4>Photoshop<span>85%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width: '85%'}}></div></div>
</div>
<h4>Illustrator<span>65%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100" style={{width: '65%'}}></div></div>
</div>
<h4>Adove XD<span>35%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" style={{width: '35%'}}></div></div>
</div>
<h4>Flash<span>45%</span></h4>
<div className="skill-border">
    <div className="progress"><div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" style={{width: '45%'}}></div></div>
</div>


</div>






</div>



</div>

                                            </div>
											
											
                                            </div>						
											
                 
				</div>
            </section>

</>



        )

    }

}
export default ResumeComponent